import { render, staticRenderFns } from "./RegionCards.vue?vue&type=template&id=1be7ab9e&scoped=true"
import script from "./RegionCards.vue?vue&type=script&lang=js"
export * from "./RegionCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be7ab9e",
  null
  
)

export default component.exports